export default __webpack_public_path__ + "static/media/Aerial2.6e5d4c88.jpg";